import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import _ from 'lodash';
import { connect } from 'react-redux';
import SeriesContainer from './SeriesContainer';

const OverviewContainer = ({ clientId, workoutLogs, setTableTemp, table, ...props}) => {
  const [formattedObject, setFormattedObject] = useState({})
  useEffect(() => {
    let temp = groupLogs(workoutLogs)
    setFormattedObject(temp)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workoutLogs])

  return (
    <div className="overview-container">
        {
        workoutLogs.length < 1 ?
          <p> NO WORKOUTS LOGGED YET </p>
          :
          ''
        }
        { Object.keys(formattedObject)?.map((log, index) => {
          return (
            <Accordion defaultActiveKey={0} key={index}>
              <Card key={log} className="workout-accordion">
                <Accordion.Toggle as={Card.Header} eventKey={index} >
                { log }
                  <i className="fas fa-sort-down"></i>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={index}>
                  <div>
                  {
                  Object.keys(formattedObject[log])?.map(series => {
                    return(
                      <Card.Body key={series}>
                        <SeriesContainer name={series} workout={log} setTableTemp={setTableTemp} table={table} series={formattedObject[log][series]}/>
                      </Card.Body>
                    )
                  })
                  }
                  </div>
                </Accordion.Collapse>
              </Card>
            </Accordion>
            )
          })
        }
    </div>
  );
}

function groupLogs(logs) {
  const logsWithNewFields = logs.map(log => {
    return {...log, fullName: `${log.name} ${log.phase} ${log.level}`}
  })
  let flatMaps = [];
  logsWithNewFields.forEach(log => {
    log.series.forEach(series => {
      (series.sets || []).forEach((set, i) => {
        set.exercises.forEach(exercise => {
          let flatmap = {
            ...log,
            ...series,
            ...set,
            ...exercise,
            set_number: `set ${i}`
          }
          flatmap = _.omit(flatmap, 'series')
          flatmap = _.omit(flatmap, 'sets')
          flatmap = _.omit(flatmap, 'exercises')
          flatMaps.push(flatmap)
        })
      })
    })
  })
  const groupedByWorkout = _.groupBy(flatMaps,'fullName')
  const workout_keys = Object.keys(groupedByWorkout)

  workout_keys.forEach(key => {
    const groupedBySeries = _.groupBy(groupedByWorkout[key], 'series_name')
    const seriesKeys = Object.keys(groupedBySeries)
    seriesKeys.forEach(seriesKey => {
      const groupedByExercises = _.groupBy(groupedBySeries[seriesKey], 'exercise_name')
      groupedBySeries[seriesKey] = groupedByExercises
    })
    groupedByWorkout[key] = groupedBySeries
  })

  return groupedByWorkout
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(OverviewContainer);
